(function () {
  function money(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return v + ' €';
  }

  function render() {
    var grid = document.getElementById('ep-wishlist-page-grid');
    var empty = document.getElementById('ep-wishlist-page-empty');
    if (!grid) return;

    var list = (window.epWishlist && window.epWishlist.getList) ? window.epWishlist.getList() : [];

    grid.innerHTML = '';

    if (!list.length) {
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    list.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('not-found');
          return r.json();
        })
        .then(function (p) {
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var card = document.createElement('div');
          card.className = 'ep-wishlist-page__card';
          card.setAttribute('data-handle', handle);

          var safeTitle = (p.title || '').replace(/"/g, '&quot;');

          card.innerHTML =
            '<a href="/products/' + handle + '" class="ep-wishlist-page__card-link">' +
              '<div class="ep-wishlist-page__card-image">' +
                (img ? '<img src="' + img + '" alt="' + safeTitle + '" loading="lazy">' : '') +
              '</div>' +
              '<div class="ep-wishlist-page__card-title">' + (p.title || '') + '</div>' +
              '<div class="ep-wishlist-page__card-price">' + money(p.price) + '</div>' +
            '</a>' +
            '<button type="button" class="ep-wishlist-page__card-remove" data-ep-wishlist-toggle data-product-handle="' + handle + '" aria-label="Pašalinti iš mėgstamų">&times;</button>';

          grid.appendChild(card);
        })
        .catch(function () {
          // product no longer exists or is unavailable — skip silently
        });
    });
  }

  document.addEventListener('DOMContentLoaded', render);
  document.addEventListener('ep-wishlist:change', render);
  if (document.readyState !== 'loading') render();
})();
